import styles from "./index.module.less";
export default function MediumEnterprises({ config, isMobile }) {
  return (
    <div
      className={styles.content}
      style={{
        backgroundImage: `url(${
          isMobile
            ? config?.mediumImgMobile?.[0]?.url
            : config?.newMediumImg?.[0]?.url
        })`,
      }}
    >
      <div className={styles.cardContent}>
        {config?.midsize?.map((item, index) => {
          return (
            <div key={index} className={styles.mediumEnterprisesCard}>
              <div>
                <img src={item.icon[0]?.url} alt="" width={54} />

                <div className={styles.cardTitle}>
                  <span className={styles.line}></span>
                  {item.title}
                  <span className={styles.line}></span>
                </div>
                <div className={styles.cardDesc}>{item.desc}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
